import { makeStyles } from '@surveycake/rc';

const innerWidth = 800;

export const useStyles = makeStyles([
  [
    'footer',
    (theme, [fatFooter]) => `
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		height: ${fatFooter ? 60 : 40}px;
		font-size: 12px;
		background-color: ${theme.color.text.white};
		padding: 10px 15px;
		box-shadow: ${theme.survey.color.gray} 0 -1px 2px 0;
		box-sizing: border-box;
		z-index: 10;
	`
  ],
  [
    'inner',
    `
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		max-width: ${innerWidth}px;
		margin: 0 auto;
		padding: 0;
		height: 100%;
	`
  ],
  [
    'footerRight',
    `
		display: flex;
		justify-content: space-between;
		align-items: center;
	`
  ]
]);
